import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '@mlb/react-patterns/style/helpers/media.ts';

import { useMediaConfigHome } from 'bdvp-common/src/hooks/config';
import { useDidUpdate } from 'bdvp-common/src/hooks';
import NotificationContainer from 'bdvp-common/src/containers/Notification';
import NotificationRenderer from 'bdvp-common/src/components/NotificationRenderer';
import LazyLoad from 'bdvp-common/src/components/LazyLoad';
import Spinner from 'bdvp-common/src/components/Spinner';

import { FILTER_ANIMATION_SECONDS } from '../../utils/constants';
import useIsFilterInModal from '../../hooks/useIsFilterInModal';
import Section from '../Section';

const Notification = styled(NotificationContainer)`
    margin: 20px 14px 0px 14px;

    ${media.mdmin`
        margin: 25px 16px 0px 16px;
    `}

    ${media.lgmin`
        margin: 25px 32px 0px 32px;
    `}
`;

const Wrapper = styled.div`
    display: grid;
    grid-template-columns: 100%;
    gap: 30px;
    padding: 25px 0 30px;
`;

const SpinnerWrapper = styled.div`
    display: flex;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
`;

const parse = (value) => {

    try {

        return JSON.parse(value); 

    } catch(e) {

        return value; 

    }

};

const Homepage = ({
    data,
    isLoading,
    isFilterModalOpen,
}) => {

    const isFilterInModal = useIsFilterInModal();
    const config = useMediaConfigHome();
    const { fallbackContainer = {} } = config;
    useDidUpdate(() => {

        if(!isFilterInModal) {

            setTimeout(() => {

                window.dispatchEvent(new Event('resize'));

            }, FILTER_ANIMATION_SECONDS / 1000);

        }

    }, [isFilterModalOpen]);

    const container = !isLoading
        ? data?.containers?.containers?.[0] ?? fallbackContainer
        : {};
    const sections = container.sections ?? [];

    return (
        <>
            <NotificationRenderer
                config={config}
                render={(id, contentConfig) => (
                    <Notification id={id} contentConfig={contentConfig} />
                )}
            />
            <Wrapper>
                {isLoading
                    ?   (
                        <SpinnerWrapper>
                            <Spinner />
                        </SpinnerWrapper>
                    )
                    : sections.map((section, index) => {

                        const fields = section.fields.reduce((acc, curr) => ({
                            ...acc,
                            [curr.name]: curr.type === "OBJECT" ? parse(curr.value) : curr.value,
                        }), {});
                        return (
                            <LazyLoad
                                key={section.id}
                                render={({
                                    elementRef,
                                    isVisible,
                                }) => (
                                    <Section
                                        ref={elementRef}
                                        type={section.type.name}
                                        skip={!isVisible}
                                        ssr={false}
                                        properties={fields}
                                        rank={index}
                                        applyClubRenderConditions
                                    />
                                )}
                            />
                        );

                    })}

            </Wrapper>
        </>
    );

};

Homepage.propTypes = {
    data: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isFilterModalOpen: PropTypes.bool.isRequired,
};

export default Homepage;
